import React, { useEffect, useState } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import Button from '../../utils/components/Button/Button'
import useModal from '../../utils/hooks/useModal'
import queryString from 'query-string';
import { getQr } from '../../actions/marketPlaceActions';
import { getAllWareHouses } from '../../admin/actions/wareHouseActions';
import Navbar from '../../containers/Navbar/Navbar/Navbar';
import BackGroundLogin from '../../assets/img/background.png';
import localStorage from '../../utils/hooks/useLocalStorage';
export const SuccessPayment = ({ history, location }) => {
    const dispatch = useDispatch()
    const { qrImg } = useSelector(state => state.marketPlace)
    const { wareHouseList } = useSelector((state) => state.WareHouse);
    const [refModal, isShowModal, setIsShowModal] = useModal(false)
    let { preference_id, token } = queryString.parse(location.search)
    const [wareHause, setWareHause] = useState("");
   

    useEffect(() => {

        dispatch(getQr(preference_id, token))


    }, [preference_id, token]);
    const download = e => {
        //     console.log();
        fetch(e, {
            method: "GET",
            headers: {}
        })
            .then(response => {
                response.arrayBuffer().then((buffer) => {
                    const url = window.URL.createObjectURL(new Blob([buffer]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "qr.png"); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                });
            })
            .catch(err => {
                console.log();
            });
    };
    const divStyle = {
        display: isShowModal ? 'block' : 'none'
    };
    return (
        <div>
            {!localStorage().getItem('statusLog')  && <Navbar islogin={false} />}
            {!localStorage().getItem('statusLog') && <img className={`background-login ${false ? 'login' : ''}`} src={BackGroundLogin} alt="imagen de login"></img>}
            <div className='row centerItems mt-5 modal-content p-5'>
            
                <div>
                    Con este código QR podrás reclamar tus productos.
                </div>
                <div style={{
                    width: "300px",
                    height: "300px",

                }}>
                    <img height={300} src={qrImg && qrImg.url.origin} alt="" />
                </div>
                <div >
                    {qrImg && <strong onClick={e => download(qrImg.url.origin)} href={qrImg.url.origin} >Descargar código QR</strong>}
                </div>
                <div style={{ width: "20%" }}>
                    <Button
                        onClick={() => { history.push("/MarketPlace") }}
                        text='Finalizar'
                    />
                </div>
            </div>
            )
        </div>
       
    )
}


export default SuccessPayment
